import { useQuery } from '@tanstack/react-query';
import { apiClient, unwrap } from '@/shared/api-client/workspace';
import type { components } from '@/shared/api-client/workspace/schema';

export type CustomerProfile = Required<
  Omit<components['schemas']['CustomerProfile'], 'email' | 'phone'>
> & { email: string | null; phone: string | null };
export type CustomerMatch = Required<
  Omit<components['schemas']['CustomerMatch'], 'email' | 'phone'>
> & { email: string | null; phone: string | null };

export function useCustomerSearch(venueId: string, query: string, enabled: boolean) {
  return useQuery({
    queryKey: ['customers', venueId, 'search', query],
    queryFn: () =>
      unwrap(
        apiClient.POST('/api/v1/venue-workspace/venues/{venueId}/customers/search', {
          params: { path: { venueId } },
          body: { query },
        }),
      ).then((response) => (response.items ?? []) as CustomerMatch[]),
    enabled: enabled && query.length > 0,
  });
}

export function useCustomer(venueId: string, customerId: string | null, enabled: boolean) {
  return useQuery({
    queryKey: ['customers', venueId, customerId],
    queryFn: () =>
      unwrap(
        apiClient.GET('/api/v1/venue-workspace/venues/{venueId}/customers/{customerId}', {
          params: { path: { venueId, customerId: customerId ?? '' } },
        }),
      ) as Promise<CustomerProfile>,
    enabled: enabled && customerId !== null,
  });
}
